import { render, staticRenderFns } from "./proEnvTesting.vue?vue&type=template&id=206c722c&"
import script from "./proEnvTesting.vue?vue&type=script&lang=js&"
export * from "./proEnvTesting.vue?vue&type=script&lang=js&"
import style0 from "./proEnvTesting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports